export default function createDataCenterReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_DATA_CENTER_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_DATA_CENTER_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_DATA_CENTER_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}